export const WHATSAPP = 'whatsapp';
export const FACEBOOK = 'facebook';
export const INSTAGRAM = 'instagram';
export const WEBSITE = 'website';
export const PHONECALL = 'phone';